import { User } from '@/types';

export const demoUsers: User[] = [
  {
    id: 'admin1',
    username: 'مدير النظام',
    phoneNumber: '0500000000',
    role: 'admin',
    permissions: ['*']
  },
  {
    id: 'user1',
    username: 'محمد العمري',
    phoneNumber: '0501111111',
    role: 'user',
    permissions: ['view', 'add']
  },
  {
    id: 'user2',
    username: 'أحمد العمري',
    phoneNumber: '0502222222',
    role: 'user',
    permissions: ['view', 'add']
  }
];